import React from 'react';
import { stringify } from 'rebem-classname';

export default function IconsRedesSociales({ socialIcons, block }) {
    if(!socialIcons){
        return null;
    }
    return(
        <div className={stringify({block, elem:"socialIcons"})}>
            <a target='_blank' href="https://www.facebook.com/alquilerargentina">
                <span className="icon-facebook"/>
            </a>
            <a target='_blank' href="https://www.instagram.com/alquilerargentina">
                <span className="icon-instagram"/>
            </a>
            <a target='_blank' href="https://twitter.com/AlqArgentina">
                <span className="icon-twitter"/>
            </a> 
            <a target='_blank' href="https://www.youtube.com/user/AlquilerArgentinaWeb">
                <span className="icon-youtube"/>
            </a>
            <a target='_blank' href="https://www.alquilerargentina.com/blog/">
                <span className="icon-blog"/>
            </a>
        </div>
    );
}